// @flow

import React from 'react';
import {
  Spinner,
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { useAIAssistants } from './hooks';
import AssistantCard from './AssistantCard';
import messages from './messages';

const NAME = 'ai-assistants';

/**
 * The property's AI Assistants area.
 *
 * The area itself is not gated on any assistant's feature flag - it is reachable for every
 * property, and a property with no assistant available shows the heading and nothing else.
 * That empty page is intentional: WalkMe announces what is coming there, so the app must not
 * put its own copy in the space.
 */
const AIAssistants = () => {
  const { title, isLoading, leslie, cora } = useAIAssistants();

  return (
    <Stack data-testid={NAME} spacing={2}>
      <Typography variant="headlineMedium" component="h1">
        {title}
      </Typography>
      {isLoading && <Spinner />}
      {leslie && (
        <AssistantCard
          testId="leslie"
          name={messages.leslieName}
          description={messages.leslieDescription}
          enabled={leslie.enabled}
        />
      )}
      {cora && (
        <AssistantCard
          testId="cora"
          name={messages.coraName}
          description={messages.coraDescription}
          enabled={cora.enabled}
        />
      )}
    </Stack>
  );
};

export default AIAssistants;
